module.exports = __webpack_public_path__ + "static/img/User-1.1d2a753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/User-1.png
// module id = 55
// module chunks = 7